<template>
    <div style="display:block; font-size: 1.5em;width: 100%;" v-if="item!==null && item.tags!==null && item.tags.length>0">
        <span class="label label-default" style="z-index:999;margin: 2px;display: inline-block;" v-for="tag in item.tags"> 
        {{tag.child.name }}
        </span>
    </div>
</template>
<script>
export default {
    props: {
        item: { type: Object, default: null }
    },
    data: function () {
        return {

        };
    },
    computed: {

    },
    methods: {

    },
    created: function () {

    },
    destroyed: function () {

    },
    mounted: function () {

    }
}
</script>